import React from 'react';
import '../css/Footer.css'; // Make sure to create and link this CSS file
import { Link } from "react-router-dom";
import Socials from "../components/Socials";


const Footer = () => {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-column1">
          <div className="footer-logo">
            <a className="footer-logo-part-f" href="/">F</a>
            <a className="footer-logo-part-lotec" href="/">LOTEC</a>
          </div>
          <p>Respiratory Products</p>
          <div className="image-container">
            <div className="first-image-wrapper">
              <img src="/TESTDEMO/iso1.png" alt="ISO" />
              <img src="/TESTDEMO/made-in-usa.png" alt="INDY" />
            </div>
          </div>
        </div>

        <div className="footer-column">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/faq">Common Questions</Link></li>
            <li><Link to="/sitemap">Sitemap</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Contact Us</h4>
          <p>7625 West New York Street Indianapolis IN 46214-4911</p>
          <p>Email: orderdesk@floteco2.com</p>
          <p>Phone: 317-273-6960</p>
          <p>Fax: 317-273-6979</p>
          <p>US: 800-401-1723</p>
          <p>Hours of operation: M-F | 8:00am to 5:00pm</p>
          <p>
            Contact Form:{" "}
            <a href="/contact" className="footer-link">
              Submit a request
            </a>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <Socials />
        <p>&copy; 2025 Flotec Inc. All rights reserved. | Revision B</p>
      </div>
    </footer>
  );
};

export default Footer;
